import { getData, postData } from "@/api/index";
// import { * } from "@/services/server/UserInterface";

//个人
export async function getUserController(params) {
  return await getData("UserController/pageAction", params);
}

//企业
export async function getCompanyController(params) {
  return await getData("company.CompanyController/pageAction", params);
}

export async function getCompanyTokenAction(params) {
  return await getData("manage.ManageCompanyController/companyTokenAction", params);
}
